import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { CustomTabs } from "../../../components";
import { useAuth } from "../../../context/AuthContext";
import rebateModeEnum from "../../../enumerations/rebateModeEnum";
import {
  ComissionBetAmountRebate,
  ComissionData,
  ComissionNetLoss,
  ComissionOverview,
  ComissionStatement,
} from "./components";
import { ComissionContextProvider } from "./context/ComissionContext";
import styles from "./style.module.scss";

const ComissionReport = () => {
  const { t } = useTranslation();
  const { rebateMode } = useAuth();
  const [params] = useSearchParams();
  const tabItems = [
    {
      key: "comission_data",
      title: t("mobile.comission.data"),
      component: <ComissionData />,
      destroyOnClose: true,
    },
    {
      key: "comission_overview",
      title: t("mobile.comission.overview"),
      component: <ComissionOverview />,
      destroyOnClose: true,
    },
    {
      key: "comission_statement",
      title: t("mobile.home.menu.comission"),
      component: <ComissionStatement />,
      destroyOnClose: true,
    },
    {
      key: "netloss_statement",
      title: t("mobile.comission.netloss"),
      component: <ComissionNetLoss />,
      destroyOnClose: true,
      hidden: rebateMode !== rebateModeEnum.NET_LOSS,
    },
  ];
  const [activeTab, setActiveTab] = useState("comission_data");

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const getNowTab = () => {
    const tab = params.get("tab");
    if (tab) {
      const foundTab = tabItems.find((item) => item.key === tab && item.hidden !== true);
      if (foundTab) {
        setActiveTab(tab);
      } else {
        setActiveTab(tabItems[0].key);
      }
    } else {
      setActiveTab(tabItems[0].key);
    }
  };

  useEffect(() => {
    getNowTab();
  }, []);

  const renderComissionPage = () => {
    if (rebateMode) {
      switch (rebateMode) {
        case rebateModeEnum.BETAMOUNT:
          return <ComissionBetAmountRebate />;
        case rebateModeEnum.HYBRID:
          return (
            <ComissionContextProvider>
              <ComissionBetAmountRebate hybrid={true} />
            </ComissionContextProvider>
          );
        default:
          return (
            <ComissionContextProvider>
              <div className={styles.container}>
                <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
              </div>
            </ComissionContextProvider>
          );
      }
    }
  };

  return <>{renderComissionPage()}</>;
};
export default ComissionReport;
